<section class="flex w-full flex-col">
  <app-orders-top></app-orders-top>

  <!-- Orders Status List View -->
  @if (currentView() === 'summary') {
    <div class="mt-4 flex h-full flex-col gap-4 lg:flex-row">
      <section class="ml-4 flex-1 rounded-t-2xl bg-white py-4">
        <div
          class="sticky top-20 z-3 rounded-t-2xl bg-white max-lg:rounded-none"
          #headerContainer
        >
          <div class="flex flex-wrap items-center justify-between gap-4 px-4">
            <div class="flex items-center gap-2 text-[#0f2744]">
              <mat-icon>check</mat-icon>
              <h1>Orders</h1>
            </div>

            <div class="flex items-center gap-4 text-sm">
              <div class="csv-export">
                <app-csv-download
                  [disabled]="formattedCSVData().length === 0"
                  [csvData]="formattedCSVData()"
                  [fileName]="'Orders-Status.csv'"
                  [ariaLabel]="'Export Orders CSV'"
                  [compact]="true"
                ></app-csv-download>
              </div>

              <app-orders-view-toggle
                [currentView]="currentView()"
                (viewChange)="setView($event)"
              ></app-orders-view-toggle>
            </div>
          </div>

          @if (!(isLoading$ | async)) {
            <div class="flex flex-wrap items-center justify-between gap-4 p-4">
              <label for="orders-search" class="sr-only">Search orders</label>
              <div class="relative w-full">
                <mat-icon
                  class="pointer-events-none absolute top-1/2 left-3 flex! h-4! w-4! -translate-y-1/2 items-center! justify-center! text-lg! text-black"
                  aria-hidden="true"
                  >search</mat-icon
                >
                <input
                  id="orders-search"
                  type="search"
                  class="comcast-input mt-0! pl-9 text-sm!"
                  [formControl]="searchTermControl"
                  placeholder="Search"
                  autocomplete="off"
                />
              </div>
            </div>
          }
        </div>

        <div class="flex flex-col">
          @if (filteredOrders().length > 0) {
            @if (isLoading$ | async) {
              <div class="loading-indicator">
                <mat-spinner [diameter]="50"></mat-spinner>
              </div>
            } @else if (filteredOrders().length === 0) {
              <div>
                <div
                  class="orders-empty w-full pt-8 text-center text-lg font-light text-[#0f2744]"
                >
                  There are currently no pending orders.
                </div>
                <div class="mt-7 h-px w-full bg-gray-200"></div>
              </div>
            } @else {
              <mat-accordion class="gap flex flex-col">
                @for (
                  order of filteredOrders()
                    | paginate: { itemsPerPage: 10, currentPage: page };
                  track order.Id;
                  let index = $index
                ) {
                  <div
                    class="rounded-xl bg-white/80 shadow-none"
                    id="ordersData"
                  >
                    <mat-expansion-panel
                      #panel
                      class="bg-transparent shadow-none"
                      appFocusContentOnOpen
                    >
                      <mat-expansion-panel-header
                        [collapsedHeight]="'50px'"
                        class="matDescription hover:bg-blue-75 border-b border-gray-200 px-5 py-3 transition-colors"
                        [ngClass]="panel.expanded ? 'bg-blue-75' : 'bg-gray-50'"
                        (click)="
                          onSelect({
                            detailView: 'Order',
                            orderId: order.Id,
                            lineItemId: null,
                          })
                        "
                        (keyup.enter)="
                          onSelect({
                            detailView: 'Order',
                            orderId: order.Id,
                            lineItemId: null,
                          })
                        "
                        [class.selected]="
                          order.Id === (selectedOrderId$ | async) &&
                          (detailView$ | async) === viewsObject.order &&
                          (browserSize$ | async) !== 'small'
                        "
                      >
                        <mat-panel-description class="w-full">
                          <order-list-display
                            class="block w-full"
                            [order]="order"
                            [isSelected]="
                              order.Id === (selectedOrderId$ | async) &&
                              (detailView$ | async) === viewsObject.order
                            "
                          ></order-list-display>
                        </mat-panel-description>
                      </mat-expansion-panel-header>
                      @for (
                        line of order.Customer_Order_OLI__r?.records;
                        track line.Id;
                        let lineIndex = $index
                      ) {
                        <div
                          class="border-b border-gray-200 transition outline-none focus-visible:ring-2 focus-visible:ring-[#0D62FF]"
                          tabindex="0"
                          (click)="
                            onSelect({
                              detailView: 'LineItem',
                              orderId: order.Id,
                              lineItemId: line.Id,
                            })
                          "
                          (keyup.enter)="
                            onSelect({
                              detailView: 'LineItem',
                              orderId: order.Id,
                              lineItemId: line.Id,
                            })
                          "
                          (keydown.space)="
                            $event.preventDefault();
                            onSelect({
                              detailView: 'LineItem',
                              orderId: order.Id,
                              lineItemId: line.Id,
                            })
                          "
                          [class.selected]="
                            line.Id === (selectedLineItemId$ | async) &&
                            (detailView$ | async) === viewsObject.lineItem
                          "
                        >
                          <line-item-list-display
                            [order]="order"
                            [lineItem]="line"
                            [isSelected]="
                              line.Id === (selectedLineItemId$ | async) &&
                              (detailView$ | async) === viewsObject.lineItem
                            "
                          ></line-item-list-display>
                        </div>
                      }
                    </mat-expansion-panel>
                  </div>
                }
              </mat-accordion>
            }
          }
          <pagination-controls
            (pageChange)="page = $event"
            [autoHide]="true"
            class="mt-6 flex justify-center"
          ></pagination-controls>
        </div>
      </section>

      <app-order-detail-panel
        class="hidden flex-1 rounded-tl-2xl bg-white md:block"
        [detailView]="detailView$ | async"
      ></app-order-detail-panel>
    </div>
  } @else {
    <!-- Orders Table View -->
    @if (!tableViewDetailActive()) {
      <div
        class="mx-auto flex w-full max-w-360 items-center justify-between p-5 pb-0 md:px-8"
      >
        <div class="flex items-center gap-2 text-[#0f2744]">
          <mat-icon>check</mat-icon>
          <h1>Orders</h1>
        </div>

        <div class="flex items-center gap-4 text-sm">
          <app-csv-download
            [disabled]="tableCsvData().length === 0"
            [csvData]="tableCsvData()"
            [fileName]="'Orders.csv'"
            [ariaLabel]="'Export Orders CSV'"
            [compact]="true"
          ></app-csv-download>

          <app-orders-view-toggle
            [currentView]="currentView()"
            (viewChange)="setView($event)"
          ></app-orders-view-toggle>
        </div>
      </div>
    }
    <app-orders
      (tableViewDetailActive)="onTableViewDetailActive($event)"
      (tableCsvDataChange)="onTableCsvDataChange($event)"
    ></app-orders>
  }
</section>
